import "@fontsource/montserrat";
import "@fontsource/chonburi/latin.css";
import "@fontsource/chonburi/latin-ext.css";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./src/styles/global.css";

export const shouldUpdateScroll = ({ routerProps }) => {
  return false;
};
